var EmailTemplates = $.extend(false, BaseModule ,{
    api_route : 'email-templates',

    original_data : {},
    data : {
        module:'email-templates',
        offset:20,
        page:1,
        view:'list',
        pagination      : true
    },

    init:function(){
        "use strict";
        var module_name = this.data.module,  module = this;
    }
});

$(document).ready(function(){
    "use strict";
    EmailTemplates.init();
});
